'use client';

import { createContext } from 'react';

import type { ChipGroupContextInterface } from '../types/chip-group.types';

export const ChipGroupContext = createContext<ChipGroupContextInterface>({});

ChipGroupContext.displayName = 'ChipGroup.Context';
